import { render } from "./NoticiasDestacadasComponent.vue?vue&type=template&id=35742609&scoped=true"
import script from "./NoticiasDestacadasComponent.vue?vue&type=script&lang=js"
export * from "./NoticiasDestacadasComponent.vue?vue&type=script&lang=js"

import "./NoticiasDestacadasComponent.vue?vue&type=style&index=0&id=35742609&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35742609"]])

export default __exports__